import { useFetchJson } from "../hooks/useFetchJson";


export default function WritePrefs({email, prefs, token}){
    const url = "api/user/preference/" + email;    
    const res = useFetchJson(url, prefs, "PUT", token);
    
    while(res.loading){
        return(<h4>Inserting / Updating...</h4>)
    }
    
    window.location.replace("/");
}
